<template>
  <div class="addcourse addcourseware">
    <!--面包屑-->
    <div class="crumbs">
      <span><router-link :to="{name:'EntryPage'}">首页</router-link></span> >
      <span><router-link :to="{name:'TeachManage'}">教学管理</router-link></span> >
      <span>查看课程</span>
    </div>
    <div class="courseMeesage">
      <upper :current="'tenchManage'"></upper>
    </div>
    <!--切换-->
    <div class="tabs-content">
      <div class="tabs-textstyle">
        <el-tabs v-model="activeName1"  class="tab"> <!--  @tab-click="handleClick" -->
        <el-tab-pane name="first"  class="p-table-text">
            <span slot="label" style="font-weight:bold">其他附件({{attachCount}})</span>
            <uploadDetail :updateFileList="updateFileList" :updatePicList="updatePicList" class="upL"></uploadDetail>
          </el-tab-pane>
          <el-tab-pane  name="second" class="p-table-text">
              <span slot="label" style="font-weight:bold"> 相关病例({{caseCount}})</span>
            <p-table :head="headVal" :data="dataVal" :operation="operation2" @_operation="_operation_" :autoheight="autoH" ></p-table>
          </el-tab-pane>
         <el-tab-pane  name="third" class="p-table-text">
              <span slot="label" style="font-weight:bold"> 相关影像({{studyCount}})</span>
            <p-table :operationWidth="operationWidth" :head="head" :data="data" :operation="operation" @_operation="_operation_" :autoheight="autoH" ></p-table>
          </el-tab-pane>
          <el-tab-pane   name="fourth" class="p-table-text">
            <span slot="label" style="font-weight:bold"> 学员评价({{evaluateNum}})</span>
            <review></review>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!--病例详情弹框-->
    <casePop ref="getCase"></casePop>

    <aycanImages ref="aycanImages" :hospitalId='params_image.hospitalId' :studyPk='params_image.studyPk' :studyUid='params_image.studyUid' ></aycanImages>
  </div>
</template>

<script type="text/ecmascript-6">
  import tabs from '@/components/common/tabs/tabs'
  import pTable from '@/components/common/tables/publicTable'
  import pops from '@/components/common/pops/pop'
  import uploadDetail from "@/components/common/upload/uploadDetail"
  import review from "@/components/common/review/review"
  import casePop from '@/components/common/pops/casePop'
  import upper from "@/components/common/upper/upper"
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  import {message} from '@/common/js/messages'
  import {changehosArea,changeSex,changeGender,changeAge} from '@/common/js/change'
  import {getLocalStorage, saveLocalStorage, clearLocalStorage} from '@/common/js/localStorage'
  import aycanImages from '@/components/common/base/aycanImages'

  export default {
    components: {
      tabs,
      pTable,
      pops,
      casePop,
      uploadDetail,
      review,
      upper,
      aycanImages
    },
    data() {
      return {
        page: {
          total: 0,
          currentPage: 0,
          pageSize: 30
        },
        loading: false,
        founder: '',
        medicDetail:'',
        evaluateNum:0,
        isPerson: false,
        showCheckBox: false,
        autoH:window.document.body.offsetHeight - 430,
        openFlag: '1',
        activeName1:'first',
        remark: '',
        head: [
          {
            props: 'hospitalName',
            label: '来源',
            width: '12%'
          },{
            props: 'patientId',
            label: '患者编号',
            width: '12%'
          },{
            props: 'accessionNumber',
            label: '检查号',
            width: '10%'
          },{
            props: 'patientName',
            label: '患者姓名',
            width: '12%'
          },
          {
            props: 'examTypeName',
            label: '检查类型',
            width: '10%'
          },
          {
            props: 'examBodyName',
            label: '检查部位',
            width: '15%'
          },
          {
            props: 'examDateStr',
            label: '检查时间',
            width: '20%'
          }
        ],
        headVal:
          [
            {
              props: "caseName",
              label: "病例名称"
            },
            {
              props: "privateType",
              label: "访问权限"
            },
            {
              props: "caseSex",
              label: "性别"
            },
            {
              props: "caseAge",
              label: "年龄"
            },
            {
              props: "createDateStr",
              label: "创建时间"
            },
            {
              props: "creatorName",
              label: "创建人"
            }
          ],
        operation: [
          {
            operation: '',
            class: 'icon-yuepian',
            class2: 'icon-yuepian hui',
            name: '阅片'
          }
        ],
        operation2: [{
            operation: '',
            class: 'icon-chakan',
            class2: 'icon-chakan hui',
            name: '查看'
          }
        ],
        operationWidth: '100px',
        data: [],
        dataVal: [],
        updatePicList:[],
        updateFileList:[],
        tableData: [],
        TableData:[],
        cursetypeList: [],
        subjectList: [],

        attachCount:0, //其他附件的数量
        caseCount:0, //相关病例的数量
        studyCount:0, //相关影像的数量

        params_image:{//阅片数据
          hospitalId:'',
          studyPk:'',
          studyUid:'',
        }
      }
    },
    methods: {
      getDetailList(){
        let CourseId = getLocalStorage('Id')
        let params = {
          id: CourseId
        }
          http.post('/course/getCourseDetail.json', params).then(res => {   //详情
            if (res.data.code == _.ERR_OK) {
              const {evaluateNum,attachList,studyList,caseList} = res.data.model
                this.evaluateNum = evaluateNum
                this.data = studyList//-------------影像列表
                this.dataVal = caseList //----------病例 年龄等


                this.attachCount=attachList?attachList.length:0;
                this.caseCount=caseList?caseList.length:0;
                this.studyCount=studyList?studyList.length:0;

                for (let item of this.data) {
                    item.hosArea = changehosArea(item.hosArea)
                }


                for (let item of this.dataVal) {
                  item.caseSex =  _.SEXOBJ[item.caseSex]
                  item.privateType = _.privateType[item.privateType]
                  if (item.caseAge === undefined) {
                    item.caseAge = ' '
                  } else {
                    item.caseAge = item.caseAge + changeAge(item.ageUnit)
                  }
                }

                let attachArr = attachList   //----------附件列表

                let picList = []
                let attList = []
                  attachArr.forEach( e => {
                      if (e.attach_type == "image"){
                      picList.push(e)
                    }else{
                      attList.push(e)
                    }
                  })
                this.updateFileList = attList
                this.updatePicList = picList
            }else{
              message(res.data.msg,false);
            }
          }).catch(() => {
          })
      },

      _operation_(payload){
         if (payload.operation === 'icon-yuepian') {
          this.params_image.hospitalId = this.data[payload.index].hospitalId;
          this.params_image.studyPk = this.data[payload.index].studyPk+"";
          this.params_image.studyUid = this.data[payload.index].studyUid;
          this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
            })
          // let Aycan = {
          //   hospitalId:this.data[payload.index].hospitalId,
          //   studyPk:this.data[payload.index].studyPk,
          //   studyUid:this.data[payload.index].studyUid,
          // }
          // http.post('/edu/prepareAycan.json', Aycan).then(res => {   //旧窗口请求阅片
          //   if (res.data.code == "0000") {
          //     window.open(res.data.model,'_blank');
          //   }else{
          //     message(res.data.msg,false);
          //   }
          // }).catch(() => {
          // })

        } else if (payload.operation === 'icon-chakan') {
          let params = {
            hospitalId:this.dataVal[payload.index].id,
          }
           this.$refs.getCase.openCase(payload.id)
        }
      }
    },
    created() {
      const that = this;
      this.$events.$on("toLookCourse",()=>{
        that.getDetailList();
      });
      // this.getCursetypeList()
      // this.getSubjectList()
      this.getDetailList();
    },
    beforeDestroy(){
      this.$events.$off("toLookCourse");
    },
    watch: {
      $route(to,from){
       // console.log(to.name)
        //console.log(to,from)
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .universal
    position: relative
    width: 98%
    min-width: 980px
    height 100%
    margin: auto
    overflow-y auto

  .tabs-content
    margin-top:20px
    min-height:calc(100vh - 50px - 40px - 270px)
    background: $color-index-text
    // height:500px

  .scient
    position: relative
    left: -8px

  .rtHeight
    overflow-y: auto

  .overtHeight
    height: 100%

  .rightList
    margin: 5px 10px
    float: left

  .tabs-textstyle
    position:relative

  .p-table-text
    margin:0 20px
    // height: calc(100vh - 437px);

  .addFile.upL
    // height calc(100vh - 467px + 50px )
    overflow-y auto
    min-height: 160px !important
  .addcourse .commonMedical
    height auto !important
</style>



// WEBPACK FOOTER //
// lookCourse.vue?ca0b7bbe